export default __webpack_public_path__ + "static/media/3.e528f78a.png";